export const testimony = [
    {
        id: 1,
        image: "../image/ROSS.png",
        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        name: "Ross Geller",
        location: "Lagos, Nigeria"
    },
    {
        id: 2,
        image: "../image/ROSS.png",
        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet",
        name: "Obinna Standley",
        location: "Accra, Ghana"
    }
]

export const blog = [
    {
        id: 1,
        image: "../image/blog1.png",
        title: "how to",
        title_sub: "travel alone",
        date: "24th July 2021"
    },
    {
        id: 2,
        image: "../image/blog2.png",
        title: "the japa",
        title_sub: "movement",
        date: "24th July 2021"
    },
    {
        id: 3,
        image: "../image/blog3.png",
        title: "its the",
        title_sub: "vacations for us",
        date: "24th July 2021"
    },
]

export const destinations = [
    {
        id: 1,
        image: "../image/Italy.svg"
    },
    {
        id: 2,
        image: "../image/Maldives.svg" 
    },
    {
        id: 3,
        image: "../image/Bali.svg"
    },
    {
        id: 4,
        image: "../image/Italy2.svg"
    },
    {
        id: 5,
        image: "../image/Kenya.svg"
    },
    {
        id: 6,
        image: "../image/Italy.svg"
    }
]